import * as React from "react";

import DatePicker from "material-ui/DatePicker";

import UserDetailTopBar from "./Ops.Users.UserDetailTopBar";
import UserPaymentsContainer from "app/components/AppComponents/Payments/UserPaymentsContainer";
import FileExportStatus from "../../../BOComponents/BOFileExport/BOFileExportStatus";
import { groupAuth } from "app/utils/authGroups";

import { Button, createStyles, withStyles } from "@material-ui/core";
import { compose, graphql } from "react-apollo";
import gql from "graphql-tag";

const hasAccessToWalletAdmin = groupAuth.hasAccessGroup(["Ops/Admin"]);

type State = {
  createdAtFrom: string;
  createdAtTo: string;
  fetchingData: boolean;
  exportInstructionId: string;
  error: boolean;
};

type Props = {
  setHeader: (data: { title: string; description: string }) => void;
  exportUserPayments: (
    externalReference: string,
    createdAtFrom: string,
    createdAtTo: string
  ) => Promise<string>;
  match: { [key: string]: any };
};

const styles = createStyles({
  grid: {
    padding: "10px",
  },
});

class Payments extends React.Component<any, State, Props> {
  state = {
    createdAtFrom: null,
    createdAtTo: null,
    fetchingData: false,
    exportInstructionId: null,
    error: false,
  };

  createAndGetExport = async (createdAtFrom: string, createdAtTo: string) => {
    this.setState({ fetchingData: true });
    const exportInstructionId = await this.props.exportUserPayments({
      variables: {
        createdAtTo,
        createdAtFrom,
      },
    });
    this.setState({
      exportInstructionId: exportInstructionId.data.export_user_payments,
    });
  };

  setHeader = (data: any) => {
    this.props.setHeader({
      title: `Ops > ${data.user.email}`,
      description: "Payments for user",
    });
  };

  getButtonText = () => {
    if (this.state.error) {
      return "Error, Retry?";
    }
    if (this.state.createdAtFrom && this.state.createdAtTo) {
      if (this.isDateRangeInvalid()) {
        return "Invalid date range";
      } else {
        return `Download user payment history from ${this.state.createdAtFrom.substring(
          0,
          10
        )} to ${this.state.createdAtTo.substring(0, 10)}`;
      }
    } else if (this.state.createdAtFrom) {
      return `Download user payment history from ${this.state.createdAtFrom.substring(
        0,
        10
      )} until today`;
    } else if (this.state.createdAtTo) {
      return `Download user payment history until ${this.state.createdAtTo.substring(
        0,
        10
      )}`;
    } else {
      return "Download user payment history";
    }
  };

  isDateRangeInvalid = () => {
    if (this.state.createdAtFrom && this.state.createdAtTo) {
      if (this.state.createdAtFrom > this.state.createdAtTo) {
        return true;
      }
    }
    return false;
  };

  changeFrom = (event: any, date: Date) => {
    this.setState({ createdAtFrom: date.toISOString() }, () =>
      this.getButtonText()
    );
  };

  changeTo = (event: any, date: Date) => {
    this.setState({ createdAtTo: date.toISOString() }, () =>
      this.getButtonText()
    );
  };

  render() {
    return (
      <React.Fragment>
        <UserDetailTopBar />
        <section className="padded">
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
            }}
          >
            <DatePicker
              hintText="From"
              onChange={this.changeFrom}
              style={{
                width: "200px",
                marginRight: "10px",
              }}
              textFieldStyle={{
                width: "200px",
              }}
            />
            <DatePicker
              hintText="To"
              onChange={this.changeTo}
              style={{
                width: "200px",
                marginRight: "10px",
              }}
              textFieldStyle={{
                width: "200px",
              }}
            />
          </div>

          <UserPaymentsContainer
            name={"ops.users.payments"}
            onLoaded={this.setHeader}
            externalReference={this.props.match.params.id}
            createdAtFrom={this.state.createdAtFrom}
            createdAtTo={this.state.createdAtTo}
            history={this.props.history}
          />

          {hasAccessToWalletAdmin && (
            <Button
              disabled={this.state.fetchingData || this.isDateRangeInvalid()}
              className="button no-margin"
              color={this.state.error ? "secondary" : "primary"}
              variant="contained"
              onClick={() => {
                this.createAndGetExport(
                  this.state.createdAtFrom ? this.state.createdAtFrom : "",
                  this.state.createdAtTo ? this.state.createdAtTo : ""
                );
              }}
              style={{
                alignSelf: "flex-start",
              }}
            >
              {!!this.state.exportInstructionId && this.state.fetchingData ? (
                <FileExportStatus
                  exportInstructionId={this.state.exportInstructionId}
                  fetchingData={this.state.fetchingData}
                  setFetchingData={(value) =>
                    this.setState({ fetchingData: value })
                  }
                  error={this.state.error}
                  setError={(value) => this.setState({ error: value })}
                  setExportInstructionId={(value) =>
                    this.setState({
                      exportInstructionId: value,
                    })
                  }
                />
              ) : (
                this.getButtonText()
              )}
            </Button>
          )}
        </section>
      </React.Fragment>
    );
  }
}

const exportUserPaymentsMutation = graphql(
  gql`
    mutation exportUserPayments(
      $externalReference: String!
      $createdAtFrom: String!
      $createdAtTo: String!
    ) {
      export_user_payments(
        external_reference: $externalReference
        created_at_from: $createdAtFrom
        created_at_to: $createdAtTo
      )
    }
  `,
  {
    name: "exportUserPayments",
    options: (props: any) => {
      return {
        fetchPolicy: "network-only",
        variables: {
          externalReference: props.match.params.id,
        },
      };
    },
  }
);

export default compose<any>(exportUserPaymentsMutation)(
  withStyles(styles)(Payments)
);
